import ArtifactProvider from '@/components/canvas/CanvasElementSourceProviders/ArtifactProvider';

class LongTimeExposureProvider extends ArtifactProvider {
  constructor(settings) {
    super(settings, 'longTimeExposure');
  }
}

export default LongTimeExposureProvider;
